import React from 'react';
import Assessment from '@mui/icons-material/Assessment';

const iconProps = {
  sx: {
    color: '#C9B06E',
  },
};

export const pipelineNavLink = {
  title: 'Pipeline',
  icon: <Assessment {...iconProps} />,
  href: 'pipeline',
};
